import React, {Component} from 'react';
import {Modal} from "react-bootstrap";

const Iframe = (props) => {
    return (<div dangerouslySetInnerHTML={ {__html:  props.iframe?props.iframe:""}} />);
};

class UnifiedCheckoutModal extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
        if (!this.props.src) return null;
        return (
            <Modal bsSize="large" show={this.props.show} onHide={() => {console.log("hiding bc"); this.props.onHide()}}>
                <Modal.Header closeButton>
                    <Modal.Title>Checkout</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Iframe iframe={'<iframe height="800" width="868" title="Checkout with designs.ai" src='+this.props.src+' </iframe>'}/>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default UnifiedCheckoutModal;